var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1829 8.69236L1.59354 0.112145C1.44226 0.0383546 1.27615 0 1.10784 0C0.496 0 0 0.496 0 1.10784V1.13981C0 1.28846 0.0182273 1.43656 0.0542818 1.58078L1.74153 8.32973C1.78761 8.51409 1.94347 8.65027 2.13231 8.67127L9.54827 9.49527C9.80546 9.52382 10 9.74118 10 10C10 10.2588 9.80546 10.4762 9.54827 10.5047L2.13231 11.3287C1.94347 11.3497 1.78761 11.4859 1.74153 11.6703L0.0542818 18.4192C0.0182273 18.5635 0 18.7115 0 18.8602V18.8922C0 19.504 0.496 20 1.10784 20C1.27615 20 1.44226 19.9616 1.59354 19.8878L19.1829 11.3076C19.6828 11.0638 20 10.5563 20 10C20 9.44373 19.6828 8.93618 19.1829 8.69236Z",
    fill: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.b34b996fba13e3521240115bf6515b8a.svg";
export { ForwardRef as ReactComponent };